"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantTransactionsContract = void 0;
const contract_1 = require("../base/contract");
const transactions_schemas_1 = require("../../schemas/merchant/transactions.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantTransactionsContract = (0, contract_1.createContract)({
    name: 'MerchantTransactions',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        listTransactions: {
            method: 'GET',
            path: '/:merchantId/transactions',
            body: null,
            query: transactions_schemas_1.listTransactionsQuerySchema,
            params: transactions_schemas_1.listTransactionsParamsSchema,
            headers: null,
            response: {
                success: transactions_schemas_1.listTransactionsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'List all transactions',
                description: 'Retrieves unified transaction log with filtering by type, date range, and user.',
                tags: ['Merchant', 'Transactions'],
                deprecated: false,
            },
            tests: [
                'should return paginated transactions',
                'should filter by transaction type',
                'should filter by date range',
                'should filter by user',
                'should indicate refundable redemptions',
            ],
        },
    },
});
